module.exports = __webpack_public_path__ + "videos/video-oneclick-benefit-analysis.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/oneclick/video-oneclick-benefit-analysis.mp4
// module id = 914
// module chunks = 1